import * as React from 'react';

import { cn } from '@/lib/utils';

export type SkeletonProps = React.HTMLAttributes<HTMLDivElement>;

/* A sweeping highlight rather than a pulsing opacity: on a screen holding twenty
   placeholders at once, twenty things fading in unison reads as a fault. */
const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    aria-hidden="true"
    className={cn('relative h-4 w-full overflow-hidden rounded-sm bg-surface-sunken', className)}
    {...props}
  >
    <span className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-ink/10 to-transparent" />
  </div>
));
Skeleton.displayName = 'Skeleton';

export { Skeleton };
